import { Stack } from '@mantine/core';

import { Outlet } from 'react-router-dom';

export function VaultSearchPageLayout() {
  return (
    <Stack
      p="05"
      spacing="03"
      style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}
    >
      <Outlet />
    </Stack>
  );
}
